import { BillType, IBaseQueryParameters, SortType } from '../index.js'

/**
 * This interface defines the query parameters for the endpoints available in
 * the `Summaries` endpoint class.
 */

export interface ISummariesQueryParameters extends IBaseQueryParameters {
  /** Start timestamp to filter by update date. */
  fromDateTime?: string

  /** End timestamp to filter by update date. */
  toDateTime?: string

  /** Sort by `updateDate` in ascending (`asc`) or descending (`desc`) order. */
  sort?: SortType
}

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Summaries` endpoint class.
 */
export interface ISummariesPathParameters {
  /** The congress number. For example, the value can be `117`. */
  congress?: number

  /**
   * The type of bill. The value can be any one of the following:
   *
   * - `hr`
   * - `s`
   * - `hjres`
   * - `sjres`
   * - `hconres`
   * - `sconres`
   * - `hres`
   * - `sres`
   */
  billType?: BillType
}
